import React, {ReactElement} from 'react'
import {Nullable} from '../../../../app/TypeHelpers'
import NatResidentStaticContentsComponent from '../../common/resident/NatResidentStaticContentsComponent'
import {createGuestPage, GuestPagePropsSet} from '../../../../components/shared/hoc/createGuestPage'
import {Colors} from '../../../../styledComponents/Constants'
import {BoldText} from '../../applications/common/resident/NatResidentApplicationsCommon'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {SmallPlainLink} from '../../../../styledComponents/Links'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}


class NatOwnershipTransfersTerms
    extends React.Component<Props & GuestPagePropsSet> {
    constructor(props: Props & GuestPagePropsSet) {
        super(props);
        this.state = {
        };
    }

    privacyWebURLLinkClick(): void {
        window.open('https://www.haseko-hcm.co.jp/privacy/#policy', '_blank');
    };

    render(): Nullable<ReactElement> {
        return (
            <>
                <Box>
                    <NatResidentStaticContentsComponent contents={`/resources/contents/policy/termsGuest.html`}/>
                    <Box height={'30px'}/>
                    <PolicyTitle>
                        <BoldText fontColor={Colors.Body}>個人情報保護方針</BoldText>
                    </PolicyTitle>
                    <Box height={'5px'}/>
                    <GuestSmallPlainLink onClick={this.privacyWebURLLinkClick} type={'button'}>
                        <PolicyArticle>
                            個人情報保護方針
                        </PolicyArticle>
                    </GuestSmallPlainLink>
                    <PolicyArticle>
                        をご確認ください。
                    </PolicyArticle>
                </Box>
            </>
        )
    }
}

export default createGuestPage(NatOwnershipTransfersTerms)

const PolicyTitle = styled.div`
    font-size: 16px;
    font-weight: Bold;
`
const GuestSmallPlainLink = styled(SmallPlainLink)`
    color: ${Colors.GuestPrimary};
`

const PolicyArticle = styled.div`
    font-size: 14px;
    display: inline-block;
`
